if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        // ModalDialog.hide() returns focus to the opener button via
        // removeTrapFocus(), which calls opener.focus(). For gallery images 2..N
        // that button sits below the image in normal flow, so the browser scrolls
        // the page to it on close, leaving the slide scrolled up out of view (a
        // thin sliver at the top) until the user swipes.
        //
        // On iOS Safari that focus-induced scroll fires asynchronously, so a plain
        // scrollTo() restore after super.hide() loses the race. Stop the scroll at
        // its source by forcing the opener's focus() to use { preventScroll: true }
        // for the duration of super.hide(). The scrollTo() restore is kept as a
        // belt-and-suspenders fallback for browsers that ignore preventScroll.
        const opener = this.openedBy;
        const { scrollX, scrollY } = window;

        if (opener && typeof opener.focus === 'function') {
          const originalFocus = opener.focus;
          opener.focus = function (options) {
            return originalFocus.call(this, Object.assign({}, options, { preventScroll: true }));
          };
          super.hide();
          delete opener.focus;
        } else {
          super.hide();
        }

        window.scrollTo(scrollX, scrollY);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}